/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/copy_sign.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns a value with the magnitude of the first argument and the sign of the second argument.\nThis function is similar to Java\'s Math.copySign(double magnitude, double sign) which is\nsimilar to `copysign` from IEEE 754.',
  examples: [
    'FROM employees\n| EVAL cs1 = COPY_SIGN(salary, LEAST(salary_change))',
  ],
  params: {
    magnitude: 'The expression providing the magnitude of the result. Must be a numeric type.',
    sign: 'The expression providing the sign of the result. Must be a numeric type.',
  },
};

export default docs;
